import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchCurrentCompanyUser } from '~/api/company-users';
import { useActiveCompanyId } from '~/hooks/useActiveCompany';
import { useSuspenseLoggedUser } from '~/services/user';
import { CompanyQueryKeys } from '~/types/company';

/**
 * Suspense hook returning the company-user of the logged user for the active company.
 * Mirrors `useActiveCompany`; consumers render inside the same Suspense boundaries.
 */
export const useActiveCompanyUser = () => {
  const companyId = useActiveCompanyId();
  const { data: user } = useSuspenseLoggedUser();

  const { data: companyUser } = useSuspenseQuery({
    queryKey: CompanyQueryKeys.companyUser(companyId, user.id),
    queryFn: () => fetchCurrentCompanyUser(companyId, user.id),
    staleTime: Infinity,
  });

  return companyUser;
};
